import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-quantity-picker',
  templateUrl: './quantity-picker.component.html',
  styleUrls: ['./quantity-picker.component.scss']
})

/** Component that allows you to pick a quantity
 * 
 * === INPUTS ===
 * (MANDATORY) value - will hold the quantity picked
 * min   - minimum quantity allowed
 * max   - maximum quantity allowed 
 * disableMinusButtonCondition - a boolean variable that you pass to this component. When TRUE, the minus buttom will be disabled
 * disablePlusButtonCondition  - a boolean variable that you pass to this component. When TRUE, the plus  buttom will be disabled
 * 
 * === OUTPUT ===
 * valueChanged - emits the new quantity whenever it is changed
*/
export class QuantityPickerComponent implements OnInit {

  @Input()  value;
  @Input()  min:number;
  @Input()  max:number;
  @Input()  disableMinusButtonCondition:boolean;
  @Input()  disablePlusButtonCondition:boolean;
  @Input()  useLightTheme:boolean;
  @Output() valueChanged = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {
    if(this.value==null){
      console.error("Error - Value not set for quantity picker");
    }
  }

  minusClicked(){
    if(this.min!=null && this.value<=this.min){return}
    this.value--;
    this.valueChanged.emit(this.value);
  }

  plusClicked(){
    if(this.max!=null && this.value>=this.max){return}
    this.value++;
    this.valueChanged.emit(this.value);
  }

}
